<template>
  <div class="pageCon"
       id="pageCon__13"
       v-loading="Loading"
       element-loading-text="正在生成打印模板"
       element-loading-spinner="el-icon-loading"
       element-loading-background="rgba(255, 255, 255, 0.2)">
    <div class="leftCon">
      <div class="tableWrapper tableWrapper1">
        <div class="table-header">
          <i style="font-size:24px;margin-right:10px;" class="iconfont icon-huanzhexinxi"></i>
          <span style="white-space: nowrap; font-size: 18px">患者信息</span>
          <i class="iconfont icon-zuidahua patient-max-btn" @click="showPatientFormMaxDialog = true" title="最大化"></i>
        </div>
        <div class="patientDetail patientDetail1">
          <el-form
                  status-icon
                  size="small"
                  label-width="90px"
                  label-position="left"
          >
            <el-form-item label="ID:">
              <span>{{patientinfo.id_in_hospital ? patientinfo.id_in_hospital : patientinfo.id}}</span>
            </el-form-item>
            <el-form-item label="姓名:">
              <span>{{patientinfo.name}}</span>
            </el-form-item>
            <el-form-item label="性别:">
              <span>{{patientinfo.gender}}</span>
            </el-form-item>
            <el-form-item label="年龄:">
              <span>{{patientinfo.age}}</span>
            </el-form-item>
            <el-form-item label="生日:">
              <span>{{patientinfo.birthday | formatBirthday}}</span>
            </el-form-item>
            <el-form-item label="手机号码:">
              <span>{{patientinfo.phone}}</span>
            </el-form-item>
            <el-form-item label="身份证:">
              <span>{{patientinfo.id_card_number}}</span>
            </el-form-item>
            <el-form-item label="皮肤类型:">
              <span>{{patientinfo.skin_type}}</span>
            </el-form-item>
            <el-form-item label="备注:">
              <span>{{patientinfo.note}}</span>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="tableWrapper tableWrapper2" v-show="selectType == '影像'">
        <div class="table-header">
          <i style="font-size:24px;margin-right:10px;" class="iconfont icon-huanzhexinxi"></i>
          <span style="white-space: nowrap; font-size: 18px">病历信息</span>
        </div>
        <div class="patientDetail patientDetail2">
          <el-form
                  status-icon
                  size="small"
                  label-width="90px"
                  label-position="left"
          >          
            <el-form-item label="检查编号:" v-if="diagnoseinfoClone[diagnoseIndex]">
              <span class="pop_text">{{diagnoseinfoClone[diagnoseIndex].id_in_hospital}}</span>
            </el-form-item>
            <el-form-item label="申请医生:" v-if="diagnoseinfoClone[diagnoseIndex]">
              <span>{{diagnoseinfoClone[diagnoseIndex].applicant}}</span>
            </el-form-item>
            <el-form-item label="检查医生:" v-if="diagnoseinfoClone[diagnoseIndex]">
              <!--将检查医生改为审核医生，与病历页面相对应 <span v-if="diagnoseinfoClone[diagnoseIndex].doctor">{{diagnoseinfoClone[diagnoseIndex].doctor.realname}}</span> -->
              <span v-if="diagnoseinfoClone[diagnoseIndex].doctor">{{diagnoseinfoClone[diagnoseIndex].review_doctor}}</span>
              
            </el-form-item>

            <el-form-item label="临床诊断:" v-if="diagnoseinfoClone[diagnoseIndex]">
              <span style="word-break:break-all;">{{diagnoseinfoClone[diagnoseIndex].initial_conclusion}}</span>
            </el-form-item>
            <el-form-item label="主诉:" v-if="diagnoseinfoClone[diagnoseIndex]">
              <span style="word-break:break-all;">{{diagnoseinfoClone[diagnoseIndex].complaint}}</span>
            </el-form-item>
            <el-form-item label="现病史:" v-if="diagnoseinfoClone[diagnoseIndex]">
              <span style="word-break:break-all;">{{diagnoseinfoClone[diagnoseIndex].disease_history_present}}</span>
            </el-form-item>
            <el-form-item label="既往史:" v-if="diagnoseinfoClone[diagnoseIndex]">
              <span style="word-break:break-all;">{{diagnoseinfoClone[diagnoseIndex].disease_history_before}}</span>
          </el-form-item>
            <el-form-item label="体格检查:" v-if="diagnoseinfoClone[diagnoseIndex]">
              <span style="word-break:break-all;">{{diagnoseinfoClone[diagnoseIndex].physical_examination}}</span>
            </el-form-item>
            <el-form-item label="过敏史:" v-if="diagnoseinfoClone[diagnoseIndex]">
              <span style="word-break:break-all;">{{diagnoseinfoClone[diagnoseIndex].allergy_history}}</span>
            </el-form-item>
            <el-form-item label="实验室:" v-if="diagnoseinfoClone[diagnoseIndex]">
              <span style="word-break:break-all;">{{diagnoseinfoClone[diagnoseIndex].lab}}</span>
            </el-form-item>
            <el-form-item label="家族史:" v-if="diagnoseinfoClone[diagnoseIndex]">
              <span style="word-break:break-all;">{{diagnoseinfoClone[diagnoseIndex].disease_history_family}}</span>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="tableWrapper tableWrapper2" v-show="selectType == '住院'">
        <div class="table-header">
          <i style="font-size:24px;margin-right:10px;" class="iconfont icon-huanzhexinxi"></i>
          <span style="white-space: nowrap; color:#4797b2;font-size: 18px">住院信息</span>
        </div>
        <div class="patientDetail patientDetail2">
          <el-form
                  status-icon
                  size="small"
                  label-width="90px"
                  label-position="left"
          >
            <el-form-item label="住院号:" v-if="diagnoseinfoClone[diagnoseIndex]">
              <span>{{diagnoseinfoClone[diagnoseIndex].medical_record_num}}</span>
            </el-form-item>

            <el-form-item label="入院时间:" v-if="diagnoseinfoClone[diagnoseIndex]">
              <span class="pop_text">{{diagnoseinfoClone[diagnoseIndex].inpat_date | formatDate1}}</span>
            </el-form-item>

            <el-form-item label="出院时间:" v-if="diagnoseinfoClone[diagnoseIndex]">
              <span>{{diagnoseinfoClone[diagnoseIndex].outpat_date | formatDate1}}</span>
            </el-form-item>
            <el-form-item label="住院天数:" v-if="diagnoseinfoClone[diagnoseIndex]">
              <span style="word-break:break-all;">{{diagnoseinfoClone[diagnoseIndex].inpat_days_num>0?diagnoseinfoClone[diagnoseIndex].inpat_days_num:""}}</span>
            </el-form-item>
            <el-form-item label="诊断:" v-if="diagnoseinfoClone[diagnoseIndex]">
              <span style="word-break:break-all;">{{filterConclusion(diagnoseinfoClone[diagnoseIndex].diagnosis)}}</span>
            </el-form-item>

            <el-form-item label="诊断:" v-if="diagnoseinfoClone[diagnoseIndex]">
              <span style="word-break:break-all;">{{filterConclusion(diagnoseinfoClone[diagnoseIndex].diagnosis)}}</span>
            </el-form-item>
            <el-form-item label="疗效:" v-if="diagnoseinfoClone[diagnoseIndex]">
              <span style="word-break:break-all;">{{diagnoseinfoClone[diagnoseIndex].curative_effect}}</span>
            </el-form-item>
            <el-form-item label="中/西医治疗:" v-if="diagnoseinfoClone[diagnoseIndex]">
              <span style="word-break:break-all;">{{diagnoseinfoClone[diagnoseIndex].treat_method}}</span>
            </el-form-item>

            <el-form-item label="主诊医生:" v-if="diagnoseinfoClone[diagnoseIndex]">
              <span style="word-break:break-all;">{{diagnoseinfoClone[diagnoseIndex].main_diagnosis_doctor}}</span>
            </el-form-item>


            <el-form-item label="副主任医生:" v-if="diagnoseinfoClone[diagnoseIndex]">
              <span style="word-break:break-all;">{{diagnoseinfoClone[diagnoseIndex].vice_diagnosis_doctor}}</span>
            </el-form-item>

            <el-form-item label="住院医生:" v-if="diagnoseinfoClone[diagnoseIndex]">
              <span style="word-break:break-all;">{{diagnoseinfoClone[diagnoseIndex].inpat_doctor}}</span>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="tableWrapper tableWrapper2" v-if="selectType == '手术'">
        <div class="table-header">
          <i style="font-size:24px;margin-right:10px;" class="iconfont icon-huanzhexinxi"></i>
          <span style="white-space: nowrap; color:#4797b2;font-size: 18px">手术信息</span>
        </div>
        <div class="patientDetail patientDetail2">
          <el-form
                  status-icon
                  size="small"
                  label-width="90px"
                  label-position="left"
          >
            <el-form-item label="费别::" v-if="diagnoseinfoClone[diagnoseIndex]">
              <span class="pop_text">{{diagnoseinfoClone[diagnoseIndex].relevant_info[0].fee_type}}</span>
            </el-form-item>

            <el-form-item label="诊断:" v-if="diagnoseinfoClone[diagnoseIndex]">
              <span style="word-break:break-all;">{{filterConclusion(diagnoseinfoClone[diagnoseIndex].relevant_info[0].diagnosis)}}</span>
            </el-form-item>

            <el-form-item label="主诉:" v-if="diagnoseinfoClone[diagnoseIndex]">
              <span style="word-break:break-all;">{{diagnoseinfoClone[diagnoseIndex].relevant_info[0].main_suit}}</span>
            </el-form-item>

            <el-form-item label="既往史::" v-if="diagnoseinfoClone[diagnoseIndex]">
              <span style="word-break:break-all;">{{diagnoseinfoClone[diagnoseIndex].relevant_info[0].past_history}}</span>
            </el-form-item>

            <el-form-item label="住院号:" v-if="diagnoseinfoClone[diagnoseIndex]">
              <span>{{diagnoseinfoClone[diagnoseIndex].relevant_info[0].id_in_hospital}}</span>
            </el-form-item>
            <el-form-item label="床号:" v-if="diagnoseinfoClone[diagnoseIndex]">
              <span style="word-break:break-all;">{{diagnoseinfoClone[diagnoseIndex].relevant_info[0].id_bed}}</span>
            </el-form-item>

            <el-form-item label="登记者:" v-if="diagnoseinfoClone[diagnoseIndex]">
              <span style="word-break:break-all;">{{me}}</span>
            </el-form-item>

          </el-form>
        </div>
      </div>
      <div class="tableWrapper tableWrapper2" v-if="selectType == '美容' && diagnoseinfoClone[diagnoseIndex]">
        <div class="table-header">
          <i style="font-size:24px;margin-right:10px;" class="iconfont icon-huanzhexinxi"></i>
          <span style="white-space: nowrap; color:#4797b2;font-size: 18px">美容/治疗信息</span>
        </div>
        <div class="patientDetail patientDetail2" v-if="diagnoseinfoClone[diagnoseIndex].treat_details">
          <el-form
                  status-icon
                  size="small"
                  label-width="90px"
                  label-position="left"
          >
            <el-form-item label="治疗编号:" v-if="diagnoseinfoClone[diagnoseIndex]">
              <span class="pop_text">{{diagnoseinfoClone[diagnoseIndex].treat_no}}</span>
            </el-form-item>

            <el-form-item label="治疗次数:" v-if="diagnoseinfoClone[diagnoseIndex]">
              <span class="pop_text">第{{diagnoseinfoClone[diagnoseIndex].current_times}}次/共{{diagnoseinfoClone[diagnoseIndex].total_times}}次</span>
            </el-form-item>
            <el-form-item label="门诊诊断:" v-if="diagnoseinfoClone[diagnoseIndex]">
              <span style="word-break:break-all;">{{filterConclusion(diagnoseinfoClone[diagnoseIndex].diagnosis)}}</span>
            </el-form-item>

            <el-form-item label="主诉:" v-if="diagnoseinfoClone[diagnoseIndex]">
              <span style="word-break:break-all;">{{diagnoseinfoClone[diagnoseIndex].main_suit}}</span>
            </el-form-item>
            <el-form-item label="既往史:" v-if="diagnoseinfoClone[diagnoseIndex]">
              <span style="word-break:break-all;">{{diagnoseinfoClone[diagnoseIndex].past_history}}</span>
            </el-form-item>

            <el-form-item label="操作医生:" v-if="diagnoseinfoClone[diagnoseIndex]">
              <span>{{diagnoseinfoClone[diagnoseIndex].operate_doctor}}</span>
            </el-form-item>

            <el-form-item label="首诊医生:" v-if="diagnoseinfoClone[diagnoseIndex]">
              <span style="word-break:break-all;">{{diagnoseinfoClone[diagnoseIndex].register_doctor}}</span>
            </el-form-item>

            <el-form-item label="费用:" v-if="diagnoseinfoClone[diagnoseIndex]">
              <span style="word-break:break-all;">{{diagnoseinfoClone[diagnoseIndex].fee*0.01}}</span>
            </el-form-item>
            <el-form-item label="账户余额:" v-if="diagnoseinfoClone[diagnoseIndex]">
              <span style="word-break:break-all;">{{diagnoseinfoClone[diagnoseIndex].account_balance*0.01}}</span>
            </el-form-item>

            <el-form-item label="备注:" v-if="diagnoseinfoClone[diagnoseIndex]">
              <span style="word-break:break-all;">{{diagnoseinfoClone[diagnoseIndex].remarks}}</span>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <!--<div class="tableWrapper tableWrapper3">
        &lt;!&ndash;<div class="table-header">
          <i style="font-size:24px;margin-right:10px;" class="iconfont icon-huanzhexinxi"></i>
          <span style="white-space: nowrap;">历史诊断</span>
        </div>&ndash;&gt;
        <div class="patientDetail patientDetail3">
          &lt;!&ndash;<my-table :tableHead="tableHead" :tableData="diagnoseinfo" v-on:message="getIndex"
                    :wordBook="wordbook"></my-table>&ndash;&gt;
        </div>
      
      
      </div>-->
    </div>
    <div class="rightCon">
      <div class="header">
        <div class="leftText">
          <img src="../assets/list.png" style="width:30px;height:30px;margin-right:10px;"/>
          <div class="headerText">诊疗记录</div>
        </div>
        <!--<button class="btn btn_newpatient" @click="newDiagnose" style="margin-right: 28px;font-size:15px;">新的诊断</button>-->
        <div class="filter-box">
          <div class="filter-input-item">
            <el-input v-model="filterValue" placeholder="相关诊断/治疗" size="small" @input="filterList" :clearable="true"></el-input>
          </div>
          <div class="filter-input-item">
            <el-select v-model="filterSelectedValue" placeholder="类别" size="small" @change="filterList" :clearable="true">
              <el-option
                v-for="item in filterSelectOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="history-list-wrap">
        <div class="history-list-header">
          <div class="title-item" style="width: 6%">序号</div>
          <div class="title-item" style="width: 6%">类型</div>
          <div class="title-item" style="width: 18%">更新时间</div>
          <div class="title-item" style="width: 20%">诊断</div>
          <div class="title-item" style="width: 15%">部位</div>
          <div class="title-item" style="width: 15%">影像类型</div>
          <div class="title-item" style="width: 20%">操作医生</div>
        </div>
        <div class="history-list-content">
          <div class="history-list-item" v-for="(item, index) in historyList" :key="index"
               :class="{active: (item.id === selectedId && item.diagnosisType === selectType)}"
               @click="sortList(diagnoseinfoClone, item.diagnosisType, item.id)">
            <div class="history-item" style="width: 6%">{{index + 1}}</div>
            <div class="history-item" style="width: 6%">{{item.diagnosisType==='美容'?'美容/治疗':item.diagnosisType}}</div>
            <div class="history-item" style="width: 18%">{{item.time1 | formatDate}}</div>
            <div class="history-item" style="width: 20%">{{item.doctor_conclusion | filterConclusion}}</div>
            <div class="history-item" style="width: 15%">{{item.position_detail_list}}</div>
            <div class="history-item" style="width: 15%">{{computedsType(item.images)}}</div>
            <div class="history-item" style="width: 20%">{{item.diagnoseDoctor}}</div>
          </div>
        </div>
      </div>
      <div class="scrollCon">
        <div class="diagnoseItemCon" v-for="(item, index) in diagnoseinfoClone" :key="index">
          <div class="diagnoseHeader" v-bind:style="{background: index !== 0 ? '#929292' : ''}"
               :class="{operatio: item.diagnosisType === '手术'}" v-if="item.diagnosisType === '手术'">
            <div class="baseInfoCon">
              <div style="flex: 1;display: flex;">
                <div style="display:flex;width: 200px;padding-right: 20px">
                  <div style="margin-right: 2px">手术日期:</div>
                  <div>{{item.operation_date | formatDate1}}</div>
                </div>
                <div style="display:flex;width: 200px;padding-right: 20px">
                  <div style="margin-right: 2px">状态:</div>
                  <div>{{item.operation_status}}</div>
                </div>
                <div style="display:flex;min-width: 200px;padding-right: 20px">
                  <div style="width: 70px;margin-right: 2px">手术部位:</div>
                  <div>{{item.operation_position}}</div>
                </div>
                <div style="display:flex;">
                  <div style="margin-right: 2px">手术名称:</div>
                  <div>{{item.operation_name}}</div>
                </div>
                <!--<div style="display:flex;width: 180px;padding-right: 20px">
                  <div style="margin-right: 2px">登记者:</div>
                  <div>{{me}}</div>
                </div>-->
              </div>
              <div class="btns">
                <!--<img src="../assets/love.png" style="width: 20px;height:20px;" v-if="true" class="btn"
                     @click="collect()"/>-->
                <!--<img src="../assets/love_fill.png" style="width: 20px;height:20px;" v-if="item.tagged" class="btn"
                     @click="collect(item.id,item.tagged,item)"/>-->
              </div>
            </div>
            <div class="diagnoseInfo-box">
              <div class="diagnose-suggest">
                <div style="margin-top: 14px;display: flex">
                  <div style="display:flex;width: 200px;padding-right: 20px">
                    <div style="margin-right: 2px">签字医生:</div>
                    <div>{{item.sign_doctor}}</div>
                  </div>
                  <div style="display:flex;width: 200px;padding-right: 20px;">
                    <div style="margin-right: 2px">手术医生:</div>
                    <div>{{item.operation_doctor}}</div>
                  </div>
                  <div style="display:flex;width: 200px;padding-right: 20px;">
                    <div style="margin-right: 2px">助理医师1:</div>
                    <div>{{item.assistant1}}</div>
                  </div>
                  <div style="display:flex;width: 200px;padding-right: 20px;">
                    <div style="margin-right: 2px">助理医师2:</div>
                    <div>{{item.assistant2}}</div>
                  </div>
                  <div style="display:flex;width: 200px;padding-right: 20px;">
                    <div style="margin-right: 2px">手术费用:</div>
                    <div>{{item.operation_fee / 100}}</div>
                  </div>
                </div>
              </div>
              <div class="modify-diagnose" v-acl="['operation_order']">
                <div class="modify-btn" @click="gotoOperation(item)" v-if="item.isedit === 1">
                  <div class="iconfont modify-btn-icon">&#xe61d;</div>
                  <div>编辑</div>
                </div>
                <div class="modify-btn disabled" v-else>
                  <div class="iconfont modify-btn-icon">&#xe61d;</div>
                  <div>编辑</div>
                </div>
              </div>
            </div>
          </div>
          <div class="diagnoseHeader" v-bind:style="{background: index !== 0 ? '#929292' : ''}"
               :class="{hospitalization: item.diagnosisType === '住院'}" v-if="item.diagnosisType === '住院'">
            <div class="baseInfoCon">
              <div style="flex: 1;display: flex;">
                <div style="width: 200px;padding-right: 20px;">住院号: <span>{{item.medical_record_num}}</span></div>
                <div style="width: 200px;padding-right: 20px;">入院时间: <span>{{item.inpat_date | formatDate1}}</span></div>
                <div style="width: 200px;padding-right: 20px;">出院时间: <span>{{item.outpat_date | formatDate1}}</span></div>
              </div>
              <div class="btns">
                <!--<img src="../assets/love.png" style="width: 20px;height:20px;" v-if="true" class="btn"
                     @click="collect()"/>
                <img src="../assets/love_fill.png" style="width: 20px;height:20px;" v-if="item.tagged" class="btn"
                     @click="collect(item.id,item.tagged,item)"/>-->
              </div>
            </div>
            <div class="diagnoseInfo-box" style="margin-top: 8px">
              <div class="diagnose-suggest">
                <div style="margin-top: 14px;display: flex">
                  <div style="width: 200px;padding-right: 20px;">疗效: {{item.curative_effect}}</div>
                  <div style="padding-right: 20px;box-sizing: border-box;">诊断: {{item.doctor_conclusion |
                    filterConclusion}}
                  </div>
                </div>
              </div>
              <div class="modify-diagnose" v-acl="['inhospital_order']">
                <div class="modify-btn" @click="modifyHospitalizationData(item)" v-if="item.isedit === 1">
                  <div class="iconfont modify-btn-icon">&#xe61d;</div>
                  <div>编辑</div>
                </div>
                <div class="modify-btn disabled" v-else>
                  <div class="iconfont modify-btn-icon">&#xe61d;</div>
                  <div>编辑</div>
                </div>
              </div>
            </div>
          </div>
          <div class="checksCon1" v-if="item.diagnosisType === '住院' && item.image_hospitalization.length"
               :class="{'backgroundFirst1':index == 0}">
            <div class="image-item" v-for="image in item.image_hospitalization" :key="image.id">
              <!--showPic(image.path)-->
              <div class="image"
                   :style="`background-image: url(${hospitalization_imagesThumbnails + image.path})`"
                   @click="LookBigPhoto(image.path, image, item.id, 'hospitalized')"
              ></div>
              <div class="title">{{image.type | formatType}}</div>
            </div>
          </div>
          <div class="diagnoseHeader" v-bind:style="{background: index !== 0 ? '#929292' : ''}"
               v-if="item.diagnosisType === '影像'">
            <div class="baseInfoCon">
              <div style="flex: 1;display: flex;">
                <div style="width: 200px;padding-right: 20px;">检查编号:
                  <span style="padding-left: 6px">{{item.id_in_hospital}}</span></div>
                <div style="width: 200px;padding-right: 20px;">检查时间: <span>{{item.time}}</span></div>
                <div>申请医生: <span>{{item.applicant?item.applicant:""}}</span></div>
              </div>
              <div class="btns">
                <div class="btn print_btn" style="width:80px" @click="pr($event,item,index,true)"><i
                  class="iconfont icon-iconset0339"></i><span>下载</span></div>
                <div class="btn print_btn" style="width:80px" @click="pr($event,item,index,false)"><i
                  class="iconfont icon-dayin1"></i><span>打印</span></div>
                <img src="../assets/love.png" style="width: 20px;height:20px;" v-if="!item.tagged" class="btn"
                     @click="collect(item.id,item.tagged,item)"/>
                <img src="../assets/love_fill.png" style="width: 20px;height:20px;" v-if="item.tagged" class="btn"
                     @click="collect(item.id,item.tagged,item)"/>
              
              </div>
            </div>
            <div class="diagnoseInfo-box">
              <div class="diagnose-suggest">
                <div style="margin-bottom: 5px">
                  <template v-if="item.doctor_conclusion">
                    <span class="yes"><span style="padding-right: 10px">影像诊断:</span>{{item.doctor_conclusion |
                      filterConclusion}}</span>
                  </template>
                  <template v-else>
                    <span class="no">影像诊断:</span>
                  </template>
                  <template v-if="item.doctor_report">
                    <div style="display: flex;margin-top: 5px;">
                      <div style="padding-right: 10px">备注:</div>
                      <div style="flex: 1;">{{item.doctor_report}}</div>
                    </div>
                  </template>
                </div>
                <div>
                  <span>建议：{{item.doctor_suggestion}}</span>
                </div>
              </div>
              <div class="modify-diagnose"  >
                <div class="modify-btn"  @click="modifyDiagnosis(item)" v-if="isShowModifyDiagnosisBtn(item.time) &&
                item.isedit === 1">
                  <div class="iconfont modify-btn-icon">&#xe61d;</div>
                  <div>编辑</div>
                </div>
                <div class="modify-btn disabled" v-if="!isShowModifyDiagnosisBtn(item.time) || item.isedit !== 1">
                  <div class="iconfont modify-btn-icon">&#xe61d;</div>
                  <div>编辑</div>
                </div>
              </div>
            </div>
          </div>
          <div class="checksCon" v-if="item.diagnosisType === '影像'">
            <div class="checkTypeCon" v-for="(value, key, index2) in item.imagesByType" :key="index2"
                 :class="{'backgroundFirst':index == 0}">
              <div class="checkHeader">
                <div class="leftCheck " :class="{'fontClass':index == 0}">
                  <template v-if="key === 's' && value.length > 0">
                    <div style="margin: 5px 0">检查类型：<span>皮肤镜</span></div>
                    <div class="mirror-box" style="margin-bottom: 5px">
                      <span>镜下所见：</span>
                      <span class="mirror-content">{{item.dermoscopy_report_text}}</span>
                    </div>
                  </template>
                  <template v-if="key === '1' && value.length > 0">
                    <div style="margin: 5px 0">检查类型：<span>大体图/伍德灯</span></div>
                    <div class="mirror-box" style="margin-bottom: 5px">
                      <span>镜下所见：</span>
                      <span class="mirror-content">{{item.macro_report_text}}</span>
                    </div>
                  </template>
                  <template v-if="key === '8' && value.length > 0">
                    <div style="margin: 5px 0">检查类型：<span>CT</span></div>
                    <div class="mirror-box" style="margin-bottom: 5px">
                      <span>镜下所见：</span>
                      <span class="mirror-content">{{item.ct_report_text}}</span>
                    </div>
                  </template>
                  <template v-if="key === '16' && value.length > 0">
                    <div style="margin: 5px 0">检查类型：<span>B超</span></div>
                    <div class="mirror-box" style="margin-bottom: 5px">
                      <span>镜下所见：</span>
                      <span class="mirror-content">{{item.b_ultrasonic_report_text}}</span>
                    </div>
                  </template>
                  <template v-if="key === '32' && value.length > 0">
                    <div style="margin: 5px 0">检查类型：<span>病理</span></div>
                    <div class="mirror-box" style="margin-bottom: 5px">
                      <span>镜下所见：</span>
                      <span class="mirror-content">{{item.pathology_report_text}}</span>
                    </div>
                  </template>
                </div>
                <div class="rightbtn">
                  <div class="btn_color" v-if="key === 's' && value.length > 0"
                       @click="intellSearchResult(value,item.id)">{{differentContent.btnCon}}
                  </div>
                </div>
              </div>
              <div class="imgsCon">
                <div class="imgBackCon" v-for="(imgItem,index3) in value" :key="imgItem.id"
                     @mouseover="overImg(imgItem.id,imgItem.type,imgItem,index3)" @mouseleave="hideOverImg()"
                     @click="LookBigPhoto(imgItem.path, imgItem, patientinfo.id)">
                  <div class="img-box">
                    <img
                      :src="imageSrcPrefixThumbnails + imgItem.path"
                      @load="imgOnload"
                    />
                  </div>
                  <div class="diseasePosition">
                    {{imgItem.position_detail}}
                    <span
                      v-if="key === '1'"
                      class="wd-tag"
                      :class="{'wd-tag-active': imgItem.origin === 'WOOD'}"
                    >WD</span>
                  </div>
                  <div class="diseasePosition diseasePosition2"><span v-if="imgItem.print_time!==-30610253143000"
                                                                      style="font-size:12px;">打印：{{moments(imgItem.print_time)}}</span>
                  </div>
                  <div class="loveImg" v-if="hoverIndexOnImg === index3 && hoverDiagnoseType ===
                            imgItem.type && hoverDiagnoseId === imgItem.id" @click.stop="collectImg(imgItem.id,
                            imgItem)">
                    <img src="../assets/love.png" style="width:15px;height:15px;" v-show="imgItem.tagged === 0"/>
                    <img src="../assets/love_fill.png" style="width:15px;height:15px;"
                         v-show="imgItem.tagged === 1"/>
                  </div>
                  <!--<div class="largeImg"
                       v-if="hoverIndexOnImg === index3 && hoverDiagnoseType === imgItem.type && hoverDiagnoseId === imgItem.id">
                    <img src="../assets/large.png" style="width:15px;height:15px;"/>
                  </div>-->
                </div>
              </div>
            </div>
          </div>
          <div class="diagnoseHeader" v-bind:style="{background: index !== 0 ? '#929292' : ''}"
               :class="{cosmetology: item.diagnosisType === '美容'}" v-if="item.diagnosisType === '美容'">
            <div class="cosmetology-list-wrap">
              <div class="cosmetology-row" v-for="(detail, idx) in item.treat_details" :key="idx">
                <div class="cr-item cr-num">{{detail.detail_title}}</div>
                <div class="cr-item"><span class="label">美容/治疗项目：</span>{{detail.item_info ? detail.item_info.item_name : ''}}</div>
                <div class="cr-item"><span class="label">治疗设备/方法：</span>{{detail.device_info ? detail.device_info.device_name : ''}}</div>
                <div class="cr-item"><span class="label">治疗模块/药物：</span>{{detail.module_info ? detail.module_info.module_name : ''}}</div>
                <div class="cr-item"><span class="label">参数：</span>{{getParamStr(detail.param_value)}}</div>
                <div class="cr-btns" v-if="idx === 0">
                  <div class="modify-btn" v-acl="['export_cosmetology']" @click="continueTreat(item)" v-if="item.left_times > 0">
                    <div>继续治疗</div>
                  </div>
                  <div class="modify-btn disabled" v-acl="['export_cosmetology']" v-else>
                    <div>继续治疗</div>
                  </div>
                  <div class="modify-btn" v-acl="['export_cosmetology']" v-if="item.isedit === 1" @click="modifyCosmetology(item)">
                    <div class="iconfont modify-btn-icon">&#xe61d;</div>
                    <div>编辑</div>
                  </div>
                  <div class="modify-btn disabled" v-acl="['export_cosmetology']" v-else>
                    <div class="iconfont modify-btn-icon">&#xe61d;</div>
                    <div>编辑</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="checksCon1" v-if="item.diagnosisType === '美容' && item.image_cosmetology.length"
               :class="{'backgroundFirst2':index == 0}">
            <div class="image-item" v-for="image in item.image_cosmetology" :key="image.id">
              <!--showPic(image.path)-->
              <div
                :style="`background-image: url('${cosmetology_imagesThumbnails}${image.path}')`"
                class="image"
                @click="LookBigPhoto(image.path, image, patientinfo.id, 'hairdressing','hostoryList')"
              >
              </div>
              <div class="title" style="display: flex;justify-content: space-between">
                <div>{{image.status}}</div>
                <div>{{image.created_time | formatDate2}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="mask" v-show="showPort || resiltsVisible"></div> -->
    <!-- <div v-if="iframeStatus">66666666</div> -->
    <iframe hidden ref="iframePDF"></iframe>
    <transition name="fade">
      <div v-if="showPort" class="print-content" id="printWrapper">
        <!-- <PrintReport :data="patientinfo" :data2="diagnoseinfo[printIndex]" :images="reportObj" :isHostory="false" :isDownLoad="isDownLoad"
                     :advise="diagnoseinfo[diagnoseIndex].doctor_suggestion" v-on:message="closePrint"/> -->
      </div>
    </transition>
    <transition name="fade">
      <div v-if="resiltsVisible" class="resilts">
        <el-button @click='closeResult' style='position: absolute;right: 5.6rem;top: 2.5rem;z-index:999;' type='primary'
                   icon='el-icon-close' circle></el-button>
        <DetailedResults :wordbook="wordbook" :detail_result="detailResult" :imgList="imgListRes"
                         v-on:compare="compare"/>
      </div>
    </transition>
    <el-dialog
      title="相似图片对比"
      :visible.sync="compareDialog"
      width="90%"
      center
      top="36px"
      custom-class="similarDialog"
      modal
    >
      <div class="imgWrapper">
        <div class="chooseImgCon">
          <div class="cs-text">选择图片</div>
          <img :src="compareImgObj.choosedImg"
               :class="{'silimarImageWidth':!compareImgObj.isWidth1,'silimarImageHeight':compareImgObj.isWidth1}">
        </div>
        <div class="chooseImgCon">
          <div class="cs-text">相似图片（相似度{{(Number(compareImgObj.similarity)*100).toFixed(2)}}%）</div>
          <img :src="compareImgObj.compareImg"
               :class="{'silimarImageWidth':!compareImgObj.isWidth2,'silimarImageHeight':compareImgObj.isWidth2}">
          <div class="cs-text">{{searchKnowledgeDic(compareImgObj.disease)}}</div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="showLargeImage"
      center
      custom-class="similarDialog showBigImage_dialog"
      modal
      top="0"
      :fullscreen="true"
      :before-close="closeShowLargeImage"
      v-if="showLargeImage"
    >
      <div style="position: absolute;left: 20px;right: 20px;top: 45px;bottom:20px;display: flex;align-items: center">
        <CompareImage
          :primevalImage="primevalImage"
          :compareImageList="compareImageList"
          :isCompareImage="isCompareImage"
          :largeImgage="largeImgage"
          :largeImgage2="largeImgage2"
          :imageCompileClass="imageCompileClass"
          :imageCompileClass2="imageCompileClass2"
          :selected="selected"
          :selected2="selected2"
          :activeImage="activeImage"
          :activeImage2="activeImage2"
          @imageClick="imageClick"
          @imageDblclick="imageDblclick"
          @imageOnload="imageOnload"
          @checkImageCompile="checkImageCompile"
        ></CompareImage>
      </div>
    </el-dialog>
    <InHospitalDialog
      :openHospitalId="openHospitalId"
      :isShowInHospital="isShowInHospital"
      :toDialoPatientsData="toDialoPatientsData"
      @setInHpspitalStatus="setInHpspitalStatus()"
      @refreshHandler1="refreshHandler1"
      @refreshHandler2="refreshHandler2"
    ></InHospitalDialog>
    <el-dialog
      :visible.sync="showLargeImage1"
      center
      custom-class="similarDialog showBigImage_dialog_1"
      modal
      top="0"
      :fullscreen="true"
      @close="closePic"
    >
      <div class="bigImage">
        <Lookimage :largeImgage="largeImage"></Lookimage>
      </div>
    </el-dialog>
    <!-- 患者信息最大化对话框 -->
    <el-dialog
      title="患者信息"
      :visible.sync="showPatientFormMaxDialog"
      width="1050px"
      :close-on-click-modal="false"
      class="dialog patient-max-dialog"
      append-to-body
    >
      <div class="navBorder"></div>
      <el-form
        size="medium"
        label-width="100px"
        label-position="left"
        class="patient-max-form"
      >
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="姓名：">
              <span class="patient-val">{{patientinfo.name}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="ID：">
              <span class="patient-val">{{patientinfo.id_in_hospital ? patientinfo.id_in_hospital : patientinfo.id}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="性别：">
              <span class="patient-val">{{patientinfo.gender}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="出生日期：">
              <span class="patient-val">{{patientinfo.birthday | formatBirthday}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="年龄：">
              <span class="patient-val">{{patientinfo.age}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="手机号码：">
              <span class="patient-val">{{patientinfo.phone}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="手机号码2：">
              <span class="patient-val">{{patientinfo.phone2}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="身高(cm)：">
              <span class="patient-val">{{patientinfo.height}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="体重(kg)：">
              <span class="patient-val">{{patientinfo.weight}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="皮肤类型：">
              <span class="patient-val">{{patientinfo.skin_type}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="肤色：">
              <span class="patient-val">{{patientinfo.skin_color}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="身份证：">
              <span class="patient-val">{{patientinfo.id_card_number}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="地址：">
              <span class="patient-val">{{patientinfo.address}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="职业：">
              <span class="patient-val">{{patientinfo.profession}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="文化程度：">
              <span class="patient-val">{{patientinfo.education}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="是否吸烟：">
              <span class="patient-val">{{patientinfo.smoking}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="是否饮酒：">
              <span class="patient-val">{{patientinfo.drinking}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="饮食习惯：">
              <span class="patient-val">{{patientinfo.diet_habit}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="籍贯：">
              <span class="patient-val">{{patientinfo.native_place}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="民族：">
              <span class="patient-val">{{patientinfo.race}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="电子邮件：">
              <span class="patient-val">{{patientinfo.email}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="国别：">
              <span class="patient-val">{{patientinfo.country}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="备注：">
              <span class="patient-val">{{patientinfo.note}}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
  import _ from "lodash";
  import moment from 'moment';
  import gql from 'graphql-tag';
  import enterIntell from '../gql/enterIntell.gql';
  import Util from '../utils/utils.js'
  import api from "../api";
  import axios from "axios";
  import csrftoken from "../getToken";
  import myTable from "./Table.vue"
  import PrintReport from "./PrintReport.vue";
  import DetailedResults from "./DetailedResults.vue";
  import {lookPhoto} from "../utils/lookPhoto.js";
  import CompareImage from './CompareImage';
  import {printReport} from "../utils/printReport.js";
  import InHospital from "../utils/inHospital.js";
  import Lookimage from './LookBigImage.vue';
  import changeHostoryInfoByType from '../utils/changeHostoryInfoByType.js';
  import controllerDuration from '../utils/controllerDuration.js';
  const differentContent = {};
  if (process.env.VUE_APP_SHOW_INTEL === 'yes') {
    // differentContent.btnCon = '智能搜图详细结果';
    differentContent.btnCon = '搜图详细结果';
  } else {
    differentContent.btnCon = '搜图详细结果';
  }
  let template = {};
  const initialTime = -30610253143000;
  
  let that;
  export default {
    data() {
      return {
        differentContent,
        hospitalization_images: api.hospitalization_images,
        hospitalization_imagesThumbnails: api.hospitalization_imagesThumbnails,
        imageSrcPrefix: api.imageSrcPrefix,
        imageSrcPrefixThumbnails: api.imageSrcPrefixThumbnails,
        cosmetology_images: api.cosmetology_images,
        cosmetology_imagesThumbnails: api.cosmetology_imagesThumbnails,
        // 显示智能诊断结果
        resiltsVisible: false,
        showPort: false,
        isDownLoad: false,
        tableData: [],
        diagnoseList: [],
        diagnoseIndex: 0,
        compareDialog: false,
        printIndex: 0,
        compareImgObj: {},
        hoverDiagnoseId: -1,
        hoverIndexOnImg: -1,
        hoverDiagnoseType: -1,
        patientinfo: {},
        diagnoseinfo: [],
        detailResult: [],
        imgListRes: [],
        wordbook: {},
        me: "",
        tableHead: ["历史检查时间", "申请医生", "检查类型", "检查部位", "诊断结果"],
        reportObj: {},
        showLargeImage: false,
        diseaseName: {},
        diagnoseinfoClone: [],
        Loading: false,
        // 限制显示编辑按钮的时间值 毫秒
        // countTimeModifyDiagnosisBtn: 604800000,
        initialTime: -30610253143000, // 初始时间1000-01-01 00:00:00
        showPatientFormMaxDialog: false,
        // 住院数据
        hospitalizationData: [],
        // 历史选择列表
        historyList: [],
        selectedId: -1,
        // 手术数据
        operation: [],
        showLargeImage1: false,
        // 住院查看大图地址
        largeImage: '',
        // 参数编号数据
        parNumsOptions: [{
          label: '1',
          value: '1',
        }],
        parNumValue: '1',
        // 美容数据
        cosmetology: [],
        cosmetologyAccount:0,
        // 筛选
        filterValue: '',
        filterSelectedValue: '',
        filterSelectOptions: [
          {
            value: '影像',
            label: '影像诊断',
          },
          {
            value: '住院',
            label: '住院',
          },
          {
            value: '手术',
            label: '手术',
          },
          {
            value: '美容',
            label: '美容/治疗',
          },
        ],
        // 最出数据，筛选前的原始数据
        dataListClone: [],
      };
    },
    mixins: [lookPhoto, printReport, InHospital,changeHostoryInfoByType,controllerDuration],
    components: {
      myTable,
      PrintReport,
      DetailedResults,
      CompareImage,
      Lookimage,
    },
    async mounted() {
      this.me = localStorage.getItem("me");
      let res1 = await axios
        .request({
          method: "get",
          url: api.wordbook,
          headers: {
            "x-csrf-token": csrftoken
          },
          withCredentials: true
        })
      this.wordbook = res1.data;
      let msg;
      
      // Method1: get info from  sessionStorage
      // if (window.sessionStorage && window.sessionStorage.getItem('diagnosisParams')) {
      //   msg = JSON.parse(window.sessionStorage.getItem('diagnosisParams'));
      // } else {
      //   msg = this.$router.currentRoute.params;
      // }

      // Method2: get info from  store.state
      msg = this.$store.state.patientDiagnosisRecordPara;

      const dataInfo = await this.getData(msg.patientId, msg.selectId);
      // console.log("In patientDiagnoseRecode mounted()-getData(), patientId and selectId:", msg.patientId, msg.selectId);
      // console.log("result dataInfo:", dataInfo);
      this.diagnoseinfo = dataInfo.diagnoseinfo;
      this.patientinfo = dataInfo.patientinfo;
      // this.diagnoseIndex = dataInfo.index;
      // let firstIndexObj = this.diagnoseinfo.splice(this.diagnoseIndex, 1)[0];
      // this.diagnoseinfo.unshift(firstIndexObj);
      // this.diagnoseIndex = 0;
      if (!!this.diagnoseinfo && this.diagnoseinfo.length > 0) {
        for (let i = 0; i < this.diagnoseinfo.length; i++) {
          this.diagnoseinfo[i].imagesByType = {
            s: [],
            1: [],
            8: [],
            16: [],
            32: []
          };
          
          
        }
      }
      const response = await axios.request({
        method: 'get',
        url: api.knowledgeDic,
      });
      this.diseaseName = response.data;
      await this.queryMyTemplate();
      await this.dealDiagnoses();
      // 将住院数据添加进去
      for (const item of this.hospitalizationData) {
        item.diagnosisType = '住院';
        item.time1 = item.update_time;
        item.doctor_conclusion = item.diagnosis;
        item.diagnoseDoctor = item.main_diagnosis_doctor;
        item.images = '住院';
      }
      for (const item of this.operation) {
        item.diagnosisType = '手术';
        item.time1 = item.update_time;
        item.doctor_conclusion = item.relevant_info?item.relevant_info[0].diagnosis:"";
        item.diagnoseDoctor = item.operation_doctor;
        item.position_detail_list = item.operation_position;
        item.images = '手术';
      }
      for (const item of this.cosmetology) {
        item.diagnosisType = '美容';
        item.account_balance = this.cosmetologyAccount;
        item.time1 = item.update_time;
        item.doctor_conclusion = item.diagnosis;
        for (const item1 of item.treat_details) {
          item1.value = item1.detail_title;
          item1.label = item1.detail_title;
        }
        if (item.treat_details.length) {
          if (item.treat_details[0].item_info) {
            item.item_name = item.treat_details[0].item_info.item_name;
          }
          if (item.treat_details[0].device_info) {
            item.device_name = item.treat_details[0].device_info.device_name;
          }
          if (item.treat_details[0].module_info) {
            item.module_name = item.treat_details[0].module_info.module_name;
          }
          if (item.treat_details[0].param_value) {
            item.param_value = JSON.parse(item.treat_details[0].param_value);
          }
          item.showParNum = item.treat_details[0].value;
        } else {
          item.item_name = '';
          item.device_name = '';
          item.module_name = '';
          item.param_value = [];
        }
      }
      this.diagnoseinfoClone = this.diagnoseinfo.concat(this.hospitalizationData, this.operation, this.cosmetology).sort((a, b) =>
        b.time1 - a.time1);
      this.dataListClone = _.cloneDeep(this.diagnoseinfoClone); // 列表数据真拷贝备份
      this.historyList = _.cloneDeep(this.diagnoseinfoClone);
      this.sortList(this.diagnoseinfoClone, msg.diagnosisType, msg.selectId);
    },
    watch: {
      compareDialog(newval) {
        if (!newval) {
          this.compareImgObj = {};
        }
      },
      /*diagnoseinfo: {
        handler(newval, oldval) {
          this.diagnoseinfo = newval;
          this.dealDiagnoses();
        },
        deep: true,
        immediate: true
      }*/
    },
    methods: {
      // 筛选列表
      filterList() {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          let filterArr = this.dataListClone;
          if (this.filterSelectedValue) {
            filterArr = this.dataListClone.filter((item) => item.diagnosisType === this.filterSelectedValue);
          }
          if (this.filterValue) {
            filterArr = filterArr.filter((item) => {
              return this.filterConclusion(item.doctor_conclusion).indexOf(this.filterValue) >= 0;
            });
          }
          this.diagnoseinfoClone = _.cloneDeep(filterArr);
          this.historyList = _.cloneDeep(filterArr);
          if (filterArr.length) {
            this.sortList(this.diagnoseinfoClone, filterArr[0].diagnosisType, filterArr[0].id);
          }
        }, 200);
      },
      // 编辑美容
      modifyCosmetology(item) {
        this.$store.commit('addModifyCosmetology', {
          patient_id: item.patient_id,
          treat_no: item.treat_no,
          current_times: item.current_times,
          total_times: item.total_times,
          parent_id: item.parent_id ? item.parent_id : item.treat_no,
        });
        this.$router.push({name: 'hairdressing'})
      },
      // 继续治疗
      continueTreat(item) {
        this.$store.commit('addContinueTreat', {
          patient_id: item.patient_id,
          left_times: item.left_times,
          total_times: item.total_times,
          treat_no:item.treat_no,
          parent_id: item.parent_id ? item.parent_id : item.treat_no,
          current_times: item.current_times,
        });
        this.$router.push({name: 'hairdressing'})
      },
      getParamStr(param_value) {
        if (!param_value) return '';
        try {
          const parsed = JSON.parse(param_value);
          return parsed.map(p => p.value).join(';');
        } catch (e) {
          return param_value;
        }
      },
      selectedParNumChange(detail_title, item) {
        const filterArr = item.treat_details.filter((item1) => item1.detail_title === detail_title);
        if (filterArr[0].item_info) {
          item.item_name = filterArr[0].item_info.item_name;
        }
        if (filterArr[0].device_info) {
          item.device_name = filterArr[0].device_info.device_name;
        }
        if (filterArr[0].module_info) {
          item.module_name = filterArr[0].module_info.module_name;
        }
        if (filterArr[0].param_value) {
          item.param_value = JSON.parse(filterArr[0].param_value);
        }
        item.showParNum = detail_title;
      },
      closePic() {
        this.largeImage = '';
      },
      showPic(path) {
        this.largeImage = `${this.hospitalization_images}${path}`;
        this.showLargeImage1 = true;
      },
      gotoOperation(data) {
        this.$store.commit("setoperationClearClick", true);
        this.$store.commit("seteditOperation", true);
        this.$store.commit("setoperationPatientId", this.patientinfo.id);
        this.$store.commit("setoperationElectiveId", data.id);
        this.$store.commit("setoperationRelevantId", data.relevant_info[0].id);
        this.$router.push({name: "operation"});
      },
      refreshHandler1(data) {
        const findIndex = this.diagnoseinfoClone.findIndex((item) => {
          return item.diagnosisType === '住院' && item.id === data.id;
        });
        this.$set(this.diagnoseinfoClone[findIndex], 'medical_record_num', data.medical_record_num);
        this.$set(this.diagnoseinfoClone[findIndex], 'inpat_date', data.inpat_date);
        this.$set(this.diagnoseinfoClone[findIndex], 'outpat_date', data.outpat_date);
        this.$set(this.diagnoseinfoClone[findIndex], 'doctor_conclusion', data.diagnosis);
        this.$set(this.diagnoseinfoClone[findIndex], 'curative_effect', data.curative_effect);
      },
      refreshHandler2(data) {
        const findIndex = this.diagnoseinfoClone.findIndex((item) => {
          return item.diagnosisType === '住院' && item.id === data.id;
        });
        this.$set(this.diagnoseinfoClone[findIndex], 'image_hospitalization', data.images);
      },
      // 对显示的列表进行排序
      sortList(dataList, type, selectId) {
        this.selectType =type;
        const findIndex = dataList.findIndex(item => {
          return item.diagnosisType === type && item.id === selectId;
        });
        if (findIndex > -1) {
          const firstIndexObj = dataList.splice(findIndex, 1)[0];
          dataList.unshift(firstIndexObj);
        }
        this.selectedId = selectId
      },
      computedsType(imgs) {
        if (!imgs) {
          return ''
        }
        if (imgs ==='住院') {
          return '大体图'
        }
        if (imgs ==='手术') {
          return '-'
        }
        let typeArr = [];
        for (let j = 0; j < imgs.length; j++) {
          let typeString = "";
          switch (imgs[j].type) {
            case Util.SOAK.code:
              typeString = "皮肤镜";
              break;
            case Util.POLARRIZE.code:
              typeString = "皮肤镜";
              break;
            case Util.GENERAL.code:
              typeString = "大体图/伍德灯";
              break;
            case Util.CT.code:
              typeString = "CT";
              break;
            case Util.BC.code:
              typeString = "B超";
              break;
            case Util.PATHOlOGY.code:
              typeString = "病理";
              break;
          }
          typeArr.push(typeString);
        }
        typeArr = _.uniq(typeArr);
        return typeArr.toString();
      },
      // 编辑住院
      modifyHospitalizationData(item) {
        this.getInHospital(item.id, this.patientinfo);
      },
      filterConclusion(id) {
        let name;
        // 从自定义模板中找病种名称
        const f = (data) => {
          for (let i = 0; i < data.length; i++) {
            if (data[i].id === id) {
              name = data[i].name;
              break;
            } else if (data[i].children && data[i].children.length) {
              f(data[i].children);
            }
          }
        };
        if (template.myTemplate) {
          f(template.myTemplate);
        }
        // 如果自定义中没有找到则在原始模板中查找
        if (!name) {
          if (that.wordbook[id]) {
            name = that.wordbook[id].name
          }
        }
        return name ? name : id;
      },
      // 获取医生自定义模板
      async queryMyTemplate() {
        // 请求医生自定义的模板路径
        const res = await this.$apollo.query({
          query: gql`{
          me{
            id
            template
          }
        }`,
          fetchPolicy: 'no-cache',
        });
        // 根据路径请求模板
        const path = res.data.me.template;
        // 如果没有自定义模板
        if (path === '') {
          return;
        }
        const msg = await axios.request({
          method: 'get',
          url: api.template + path,
        });
        template = msg.data;
      },
      // 编辑诊断
      modifyDiagnosis(itemData) {
        this.$store.commit('addModifyDiagnosis', {patientinfo: this.patientinfo, diagnosisinfo: itemData,
          diagnosisId: itemData.id});
        this.$router.push('/home/intell');
      },
      // 是否显示编辑按钮
      isShowModifyDiagnosisBtn(date) {
        return !(moment().diff(date) >= this.countTimeModifyDiagnosisBtn);
      },
      // 比较两张图的细节
      compare(data) {
        data.choosedImg = data.choosedImg.replace("thumbnails/", "");
        this.compareImgObj.choosedImg = data.choosedImg;
        this.compareImgObj.compareImg = data.compareImg;
        this.compareImgObj.similarity = data.similarity;
        this.compareImgObj.disease = data.disease;
        this.compareImgObj.isWidth1 = data.isWidth1;
        this.compareImgObj.isWidth2 = data.isWidth2;
        this.compareDialog = true;
      },
      getIndex(message) {
        let index = message.index;
        this.diagnoseIndex = index;
        this.diagnoseinfoClone = _.clone(this.diagnoseinfo);
        this.diagnoseinfoClone = this.diagnoseinfoClone.sort((a, b) => {
          return Number(b.id_in_hospital.split('-')[1]) - Number(a.id_in_hospital.split('-')[1]);
        });
        let firstIndexObj = this.diagnoseinfoClone.splice(this.diagnoseIndex, 1)[0];
        this.diagnoseinfoClone.unshift(firstIndexObj);
        this.diagnoseIndex = 0;
      },
      closeResult() {
        this.resiltsVisible = false;
      },
      closePrint(message) {
        if (message.type === "back") {
          this.showPort = false;
        } else if (message.type === "loading") {
          this.Loading = false;
        }
      },
      moments(date) {
        return moment(date).format("YYYY-MM-DD HH:mm:ss");
      },
      // 新的诊断
      newDiagnose(event) {
        event.cancelBubble = true;
        let params = this.patientinfo;
        params.address = params.address !== "undefined" ? params.address : "";
        params.country = params.country !== "undefined" ? params.country : "";
        params.email = params.email !== "undefined" ? params.email : "";
        params.native_place = params.native_place !== "undefined" ? params.native_place : "";
        params.profession = params.profession !== "undefined" ? params.profession : "";
        this.$store.commit("setPToIntell", params);
        this.$router.push({name: "Intell"});
      },
      // 收藏或者是取消收藏
      async collect(id, taggedStatus, item) {
        let self = this;
        try {
          let collectionRes = await this.$apollo.mutate({
            mutation: gql`mutation ($id: Int!,$tagged: Boolean){
            modifyDiagnosis(id: $id,tagged: $tagged)
          }`,
            variables: {
              id,
              tagged: !taggedStatus
            }
          })
          if (!taggedStatus) {
            this.$message({
              type: "success",
              message: "收藏成功"
            });
          } else {
            this.$message({
              type: "success",
              message: "取消收藏成功"
            })
          }
          // 更改该诊断的收藏标记
          item.tagged = !taggedStatus;
        } catch (e) {
          this.$message.error("收藏失败");
        }
      },
      // 重新处理图片
      async dealDiagnoses() {
        try {
          for (let k = 0; k < this.diagnoseinfo.length; k++) {
            for (let i = 0; i < this.diagnoseinfo[k].images.length; i++) {
              let self = this;
              await new Promise((resolve, reject) => {
                let img = new Image();
                img.src = api.imageSrcPrefixThumbnails + self.diagnoseinfo[k].images[i].path;
                img.onload = () => {
                  let width = img.width;
                  let height = img.height;
                  if (width / height < 130 / 100) {
                    //
                    img.height = 100;
                    img.width = width * 100 / height;
                  } else {
                    img.width = 130;
                    img.height = height * 130 / width;
                  }
                  self.diagnoseinfo[k].images[i].width = img.width;
                  self.diagnoseinfo[k].images[i].height = img.height;
                  resolve();
                }
              })
              switch (this.diagnoseinfo[k].images[i].type) {
                case Util.SOAK.code:
                  self.diagnoseinfo[k].imagesByType.s.push(self.diagnoseinfo[k].images[i]);
                  break;
                case Util.POLARRIZE.code:
                  self.diagnoseinfo[k].imagesByType.s.push(self.diagnoseinfo[k].images[i]);
                  break;
                case Util.GENERAL.code:
                  self.diagnoseinfo[k].imagesByType['1'].push(self.diagnoseinfo[k].images[i]);
                  break;
                case Util.CT.code:
                  self.diagnoseinfo[k].imagesByType['8'].push(self.diagnoseinfo[k].images[i]);
                  break;
                case Util.BC.code:
                  self.diagnoseinfo[k].imagesByType['16'].push(self.diagnoseinfo[k].images[i]);
                  break;
                case Util.PATHOlOGY.code:
                  self.diagnoseinfo[k].imagesByType['32'].push(self.diagnoseinfo[k].images[i]);
                  break;
              }
              self.diagnoseinfo[k].imagesByType.s = _.unionBy(self.diagnoseinfo[k].imagesByType.s, 'id', 'type', 'path');
              self.diagnoseinfo[k].imagesByType['1'] = _.unionBy(self.diagnoseinfo[k].imagesByType['1'], 'id', 'type', 'path');
              self.diagnoseinfo[k].imagesByType['8'] = _.unionBy(self.diagnoseinfo[k].imagesByType['8'], 'id', 'type', 'path');
              self.diagnoseinfo[k].imagesByType['16'] = _.unionBy(self.diagnoseinfo[k].imagesByType['16'], 'id', 'type', 'path');
              self.diagnoseinfo[k].imagesByType['32'] = _.unionBy(self.diagnoseinfo[k].imagesByType['32'], 'id', 'type', 'path');
            }
          }
          this.$set(this.diagnoseinfo);
          this.diagnoseinfoClone = this.diagnoseinfo;
          this.$forceUpdate()
        } catch (error) {
          this.$message.error(error.message.split(":")[1]);
          
        }
      },
      // 激活table的一行
      activeTableItem(index, item) {
        this.diagnoseIndex = index;
        let firstIndexObj = this.diagnoseinfo.splice(this.diagnoseIndex, 1)[0];
        this.diagnoseinfo.unshift(firstIndexObj);
        this.diagnoseIndex = 0;
      },
      // 当前鼠标悬停的位置
      overImg(diagnoseId, checkType, imgList, index) {
        this.hoverDiagnoseId = diagnoseId;
        this.hoverIndexOnImg = index;
        this.hoverDiagnoseType = checkType;
      },
      hideOverImg() {
        this.hoverIndexOnImg = -1;
        this.hoverDiagnoseType = '';
      },
      // 收藏该图片
      async collectImg(imgId, imgItem) {
        try {
          if (imgItem.tagged === 0) {
            let collectionRes = await this.$apollo.mutate({
              mutation: gql`mutation ($id: Int!,$tagged: Int){
            modifyImage(id: $id,tagged: $tagged)
          }`,
              variables: {
                id: imgId,
                tagged: 1
              }
            });
            this.$message({
              type: "success",
              message: "收藏成功"
            });
            imgItem.tagged = 1;
          } else if (imgItem.tagged === 1) {
            let collectionRes = await this.$apollo.mutate({
              mutation: gql`mutation ($id: Int!,$tagged: Int){
            modifyImage(id: $id,tagged: $tagged)
          }`,
              variables: {
                id: imgId,
                tagged: 0
              }
            });
            this.$message({
              type: "success",
              message: "取消收藏成功"
            });
            imgItem.tagged = 0;
          }
        } catch (e) {
          this.$message.error("收藏失败");
        }
      },
      async largeImg(imgPath) {
        this.largeImgage = Util.IMGPATHROOT + imgPath;
        this.showLargeImage = true;
      },
      // 显示智能搜图详细结果
      async intellSearchResult(value, diagnoseId) {
        // 点击智能搜图详细结果时候讲上一次生成的数据清空
        this.imgListRes = [];
        this.detailResult = [];
        for (let n = 0; n < value.length; n++) {
          this.imgListRes.push(Util.IMGPATHROOT_SHRIK + value[n].path);
        }
        let imgsRes = await this.$apollo.query({
          query: enterIntell,
          variables: {
            id: diagnoseId
          }
        })
        let imagesList = imgsRes.data.diagnosis.images;
        for (let i = 0; i < value.length; i++) {
          let tempJson = {};
          tempJson.crop = [];
          tempJson.result = [];
          // 遍历图片数组
          for (let j = 0; j < imagesList.length; j++) {
            if (imagesList[j].id === value[i].id && imagesList[j].type === value[i].type) {
              tempJson.malignant_prob = imagesList[j].malignant_prob;
              tempJson.similar = imagesList[j].similarImages;
              let resultJson1 = {};
              resultJson1.cls_id = imagesList[j].top1;
              resultJson1.prob = imagesList[j].top1_prob;
              let resultJson2 = {};
              resultJson2.cls_id = imagesList[j].top2;
              resultJson2.prob = imagesList[j].top2_prob;
              let resultJson3 = {};
              resultJson3.cls_id = imagesList[j].top3;
              resultJson3.prob = imagesList[j].top3_prob;
              tempJson.result.push(resultJson1);
              tempJson.result.push(resultJson2);
              tempJson.result.push(resultJson3);
              for (let k = 0; k < imagesList[j].crops.length; k++) {
                let cropJson = {};
                cropJson.rect = imagesList[j].crops[k].rect;
                cropJson.result = tempJson.result;
                tempJson.crop.push(cropJson);
              }
              break;
            }
          }
          this.detailResult.push(tempJson);
        }
        this.resiltsVisible = true;
      },
      getImagesPath(ImgList, type) {
        let imgIdsRes = _.cloneDeep(ImgList);
        for (let i = 0; i < imgIdsRes.length; i++) {
          imgIdsRes[i].src = api.imageSrcPrefix + imgIdsRes[i].path;
          imgIdsRes[i].type = type;
          imgIdsRes[i].position = {};
          imgIdsRes[i].position.overviewPosition = imgIdsRes[i].position_overview;
          imgIdsRes[i].position.detailPosition = imgIdsRes[i].position_detail.split("-")[1] ? imgIdsRes[i].position_detail.split("-")[1] : "";
        }
        return imgIdsRes;
      },
      // 关闭本页
      closeDiagnoseRecord() {
        this.$emit('closeDiagnoseRecord');
      },
      // 打印报告
      pr(event, item, index, isDownLoad) {
        let self = this;
        this.isDownLoad = isDownLoad;
        event.cancelBubble = false;
        this.printIndex = index;
        let allImages = item.images;
        this.reportObj.skin = {};
        this.reportObj.skin.imgs = this.getImagesPath(item.imagesByType.s, "皮肤镜");
        this.reportObj.skin.underMirror = item.dermoscopy_report_text;
        this.reportObj.general = {};
        this.reportObj.general.imgs = this.getImagesPath(item.imagesByType['1'], "大体图/伍德灯");
        this.reportObj.general.underMirror = item.macro_report_text;
        this.reportObj.ct = {};
        this.reportObj.ct.imgs = this.getImagesPath(item.imagesByType['8'], "CT");
        this.reportObj.ct.underMirror = item.ct_report_text;
        this.reportObj.bc = {};
        this.reportObj.bc.imgs = this.getImagesPath(item.imagesByType['16'], "B超");
        this.reportObj.bc.underMirror = item.b_ultrasonic_report_text;
        this.reportObj.bl = {};
        this.reportObj.bl.imgs = this.getImagesPath(item.imagesByType['32'], "病理");
        this.reportObj.bl.underMirror = item.pathology_report_text;
        this.reportObj.diagnoseResult = this.filterConclusion(item.doctor_conclusion);
        this.reportObj.time = item.time;
        this.reportObj.otherDes = item.doctor_report;
        this.reportObj.otherDes = item.doctor_report;
        this.reportObj.review_doctor = item.review_doctor;
        this.printreport_data = this.patientinfo;
        this.printreport_data2 = this.diagnoseinfoClone[this.printIndex];
        this.printreport_images = this.reportObj;
        this.printreport_isHostory = false;
        this.printreport_isDownLoad = this.isDownLoad;
        this.printreport_advise = this.diagnoseinfoClone[this.printIndex].doctor_suggestion;
        this.PrintSubmit();
      },
      async getData(id, id2) {
        try {
          const res = await this.$apollo.query({
            query: gql`{
              patient(id: ${id}){
                id
                id_in_hospital
                name
                gender
                race
                skin_color
                skin_type
                birthday
                age
                phone
                phone2
                height
                weight
                address
                id_card_number
                native_place
                created_time
                country
                profession
                education
                smoking
                drinking
                diet_habit
                email
                note
                diagnoses{
                  id
                  isedit
                  doctor {
                    id
                    realname
                  }
                  previewImage {
                    id
                    path
                  }
                  fee
                  applicant
                  applicant_unit
                  complaint
                  review_doctor
                  unit
                  initial_conclusion
                  lab
                  id_in_hospital
                  position_detail_list
                  position_overview_list
                  disease_history_present
                  disease_history_before
                  physical_examination
                  allergy_history
                  disease_history_family
                  dermoscopy_report_text
                  dermoscopy_report_images
                  macro_report_text
                  macro_report_images
                  ct_report_text
                  ct_report_images
                  b_ultrasonic_report_text
                  b_ultrasonic_report_images
                  b_ultrasonic_report_text
                  b_ultrasonic_report_images
                  pathology_report_text
                  pathology_report_images
                  doctor_conclusion
                  doctor_report
                  doctor_suggestion
                  top1
                  top2
                  top3
                  top1_prob
                  top2_prob
                  top3_prob
                  tagged
                  is_detail_viewed
                  image_type_flag
                  time
                  images {
                    id
                    path
                    tagged
                    server
                    type
                    position_detail
                    position_overview
                    print_time
                    time
                    diagnosis{
                      id
                      time
                    }
                    origin
                  }
                }
                hospitalization{
                  id
                  isedit
                  medical_record_num
                  inpat_date
                  outpat_date
                  inpat_days_num
                  curative_effect
                  created_time
                  update_time
                  diagnosis
                  treat_method
                  main_diagnosis_doctor
                  vice_diagnosis_doctor
                  inpat_doctor
                  image_hospitalization{
                    id
                    path
                    type
                  }
                }
                operation{
                  id
                  isedit
                  create_time
                  update_time
                  operation_name
                  operation_position
                  operation_date
                  sign_doctor
                  operation_doctor
                  assistant1
                  assistant2
                  operation_fee
                  operation_status
                  relevant_info{
                          id
                          fee_type
                          diagnosis
                          main_suit
                          past_history
                          id_in_hospital
                          id_bed
                      }
                }
                account_balance
                cosmetology{
                  id
                  isedit
                  patient_id
                  treat_no
                  diagnosis
                  main_suit
                  past_history
                  operate_doctor
                  register_doctor
                  fee
                  remarks
                  create_time
                  update_time
                  total_times
                  left_times
                  current_times
                  parent_id
                  image_cosmetology{
                    id
                    path
                    status
                    created_time
                  }
                  treat_details{
                    id
                    detail_title
                    item_info{
                      id
                      item_name
                    }
                    device_info{
                      id
                      device_name
                    }
                    module_info{
                      id
                      module_name
                    }
                    param_value
                    total_times
                    left_times
                  }
                }
              }
            }`,
            fetchPolicy: "no-cache"
          });
          const patientinfo = res.data.patient;
          patientinfo.birthday = moment(res.data.patient.birthday).format('YYYY-MM-DD');
          const diagnoseinfo = res.data.patient.diagnoses;
          this.hospitalizationData = res.data.patient.hospitalization;
          this.operation = res.data.patient.operation;
          this.cosmetology = res.data.patient.cosmetology;
          this.cosmetologyAccount = res.data.patient.account_balance;

          for (let i = 0; i < diagnoseinfo.length; i++) {
            diagnoseinfo[i].time1 = diagnoseinfo[i].time;
            diagnoseinfo[i].time = moment(diagnoseinfo[i].time).format('YYYY-MM-DD HH:mm');
            diagnoseinfo[i].diagnosisType = '影像';
            diagnoseinfo[i].diagnoseDoctor = diagnoseinfo[i].doctor.realname;
          }
          const index1 = res.data.patient.diagnoses.findIndex(item => item.id === id2);
          return {
            patientinfo,
            diagnoseinfo,
            index: index1,
          }
        } catch (error) {
          this.$message.error(error.message.split(":")[1]);
        }
      },
      imgOnload(e) {
        const tag = e.target;
        if (tag.width / tag.height >= (130 / 100)) {
          const height = tag.height;
          const width = tag.width;
          const countWidth = width / (height / 100);
          e.srcElement.style.height = '100px';
          e.srcElement.style.width = countWidth + 'px';
          const s = (countWidth - 130) / 2;
          e.srcElement.style.marginLeft = '-' + s + 'px';
        } else {
          const height = tag.height;
          const width = tag.width;
          const countHeight = height / (width / 130);
          e.srcElement.style.width = '130px';
          e.srcElement.style.height = countHeight + 'px';
          const s = (countHeight - 100) / 2;
          e.srcElement.style.marginLeft = 0;
          e.srcElement.style.marginTop = '-' + s + 'px';
        }
      },
    },
    beforeCreate() {
      that = this;
    },
    filters: {
      filterConclusion(id) {
        let name;
        // 从自定义模板中找病种名称
        const f = (data) => {
          for (let i = 0; i < data.length; i++) {
            if (data[i].id === id) {
              name = data[i].name;
              break;
            } else if (data[i].children && data[i].children.length) {
              f(data[i].children);
            }
          }
        };
        if (template.myTemplate) {
          f(template.myTemplate);
        }
        // 如果自定义中没有找到则在原始模板中查找
        if (!name) {
          if (that.wordbook[id]) {
            name = that.wordbook[id].name
          }
        }
        return name ? name : id;
      },
      // 算年龄
      formatBirthday(date) {
        return date === moment(-30610253143000).format('YYYY-MM-DD') ? '' : date;
      },
      formatDate(time) {
        if (time === initialTime) {
          return '';
        } else {
          return moment(time).format("YYYY-MM-DD HH:mm");
        }
      },
      formatDate1(time) {
        if (!time) {
          return ''
        }
        if (time === initialTime) {
          return '';
        } else {
          return moment(time).format("YYYY-MM-DD");
        }
      },
      formatDate2(time) {
        if (time === initialTime) {
          return '';
        } else {
          return moment(time).format("YYYY-MM-DD HH:mm");
        }
      },
      formatType(type) {
        if (type === 1) {
          return '入院照片'
        } else if (type === 2) {
          return '出院照片'
        }
      },
    },
  };
</script>
<style lang="less">
  .el-form-item--small.el-form-item{
    margin-bottom: 1px;
  }
  #pageCon__13 .scrollCon .el-input__inner{
   /* background-color: inherit;*/
    color: rgba(0,0,0,0);
  }
  
     /*dialog关闭按钮样式*/
  #pageCon__13 .el-dialog__headerbtn{
     top: 10px;
     right: 22px;
     font-size: 24px;
   }
  #pageCon__13 .el-icon-close::before{
    color: #61a2bf;
    font-weight: bold;
  }
  .patient-max-btn {
    cursor: pointer;
    font-size: 18px;
    color: #4da2be;
    margin-left: auto;
    vertical-align: middle;
  }
  .patient-max-btn:hover {
    color: #66b1ff;
  }
  .patient-max-dialog {
    .el-dialog__header {
      .el-dialog__title {
        color: #4da2be;
      }
    }
    .el-dialog__body {
      padding: 10px 20px 20px;
      max-height: 80vh;
      overflow-y: auto;
    }
    .navBorder {
      width: 100%;
      height: 2px;
      background: #4da3c0;
    }
  }
</style>
<style lang="less" scoped>
  .header,
  .leftText,
  .diagnoseItemCon,
  .baseInfoCon,
  .diagnoseHeader,
  .btns,
  .checkTypeCon,
  .checkHeader,
  .leftCheck,
  .imgsCon,
  .imgBackCon,
  .scrollCon,
  .checksCon,
  .table-content {
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
  }
  
  .infoTitle{
  
  }
  
  .resilts {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
  }
  
  /*::-webkit-scrollbar {*/
  /*width: 5px;*/
  /*height: 100%;*/
  /*}*/
  
  /*::-webkit-scrollbar-track-piece {*/
  /*background: #fff;*/
  /*-webkit-border-radius: 6px;*/
  /*}*/
  
  /*::-webkit-scrollbar-thumb:vertical {*/
  /*background-color: #61a2bf;*/
  /*-webkit-border-radius: 6px;*/
  /*}*/
  
  .print-content {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0px;
    left: 0px;
  }
  
  .mask {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
  }
  
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }
  
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  
  .pageCon,
  .leftCon,
  .table-header,
  .tableWrapper
  .tableHeader,
  .tableItem {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: nowrap;
    flex-direction: row;
  }
  
  .pageCon {
    width: 100%;
    height: 100%;
    position: relative;
    background: #fff;
    align-items: flex-start;
    
    .leftCon {
      width: 17%;
      height: 100%;
      background: #eff3f7;
      margin-right: 1%;
      align-items: flex-start;
      flex-direction: column;
      
      .tableWrapper1 {
        height: 48% !important;
      }
      
      .tableWrapper2 {
        height: 50% !important;
      }
      
      .tableWrapper3 {
        height: 30% !important;
      }
      
      .tableWrapper {
        position: relative;
        font-size: 16px !important;
        padding: 0px 4%;
        width: 96%;
        flex-direction: column;
        align-items: flex-start;
        box-sizing: border-box;
        
        .table-header {
          width: 90%;
          display: flex;
          flex-direction: row;
          align-items: center;
          padding: 10px 2%;
          border-bottom: 1px solid #61a2bf;
          color: #4797b2
        }
        
        .table-content {
          height: 100%;
          
          .tableHeader {
            color: #61a2bf;
            font-size: 15px;
            
            .tableText {
              margin-right: 2%;
              padding: 9px 2%;
              white-space: nowrap;
            }
          }
          
          .tableItemCon {
            color: #000;
            font-size: 15px;
            overflow-y: auto;
            height: 200px;
            
            .tableItem {
              font-size: 12px;
          cursor: pointer;
              padding: 10px 1%;
              font-size: 12px;
              
              .trClass {
                margin-right: 6%;
                white-space: nowrap;
              }
            }
          }
        }
        
        .patientDetail {
          text-align: left;
          padding: 1px 4%;
          flex: 1;
          display: flex !important;
          flex-direction: column !important;
          /*justify-content: space-between !important;*/
          
          .item {
            padding: 4px 0px;
            /*flex: 1 !important;*/
          }
        }
        
        .patientDetail1 {
          overflow-y: auto;
          position: absolute;
          left: 4%;
          right: 4%;
          top: 50px;
          bottom: 0;
        }
        
        .patientDetail2 {
          overflow-y: auto;
          position: absolute;
          left: 4%;
          right: 4%;
          top: 50px;
          bottom: 0;
          
          .item2{
            padding: 4px 0;
          }
        }
        
        .patientDetail3 {
          position: absolute;
          left: 0;
          right: 4%;
          top: 45px;
          bottom: 0;
        }
      }
      
      .back-btn-box {
        width: 92%;
        padding: 10px 4%;
        border-bottom: 1px solid #61a2bf;
        
        .back-btn {
          width: 100%;
          height: 30px;
          color: #fff;
          border-radius: 10px;
          background-color: #448fa9;
          text-align: center;
          line-height: 30px;
          font-size: 14px;
          font-size: 12px;
          cursor: pointer;
          user-select: none;
        }
      }
    }
    
    .rightCon {
      height: 100%;
      width: 82%;
      
      .header {
        background: #fff;
        height: 42px;
        margin-bottom: 5px;
        flex-direction: row;
        border-bottom: 1px solid #61a2bf;
        color: #4797b2;
        justify-content: space-between;
        align-items: center;
        font-size: 19px;
        font-weight: 500;
        .filter-box{
          display: flex;
          flex-direction: row-reverse;
          align-items: center;
          height: 100%;
          width: 500px;
          .filter-input-item{
            margin-right: 20px;
          }
          .filter-input-item + .filter-input-item{
            margin-right: 10px;
          }
        }
        
        .newDiagnose {
          width: 10%;
          background: #e9af3f;
          color: #fff;
          padding: 6px 1%;
          border-radius: 5px;
          text-align: center;
          margin-right: 28px;
          font-size: 12px;
          cursor: pointer;
        }
        
        .leftText {
          margin-left: 20px;
          flex-direction: row;
          align-items: center;
        }
      }
      
      .history-list-wrap {
        display: flex;
        flex-direction: column;
        height: calc(30% - 5px);
        border-bottom: 1px solid rgb(97, 162, 191);
        margin-bottom: 10px;
        
        .history-list-header {
          display: flex;
          align-items: center;
          height: 50px;
          /*margin-right: 10px;*/
          box-sizing: border-box;
          border-bottom: 1px solid #ebebeb;
          
          .title-item {
            text-align: center;
            font-size: 15px;
            font-weight: bold;
          }
        }
        
        .history-list-content {
          flex: 1;
          box-sizing: border-box;
          overflow-y: auto;
          
          .history-list-item {
            display: flex;
            align-items: center;
            height: 43px;
            font-size: 12px;
          cursor: pointer;
            
            .history-item {
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              text-align: center;
  
              font-weight: bold;
            }
          }
          
          .history-list-item:nth-child(odd) {
            background-color: rgb(239, 242, 247);
          }
          
          .history-list-item:hover {
            background-color: rgba(156, 188, 203, 0.45);
          }
          
          .history-list-item.active {
            color: #fff;
            background-color: rgb(54, 135, 173);
          }
        }
      }
      
      .scrollCon {
        overflow-y: auto;
        height: calc(~"100% - 30% - 55px");
        
        .diagnoseItemCon {
          margin-bottom: 20px;
          min-width: 1300px;
          
          .diagnoseHeader {
            align-items: flex-start;
            background: #61a2bf;
            color: #fff;
            padding: 6px 10px;
            box-sizing: border-box;
            
            .baseInfoCon {
              width: 100%;
              flex-direction: row;
              align-items: center;
              justify-content: space-between;
              
              .btns {
                flex-direction: row;
                justify-content: flex-start;
                
                .btn {
                  height: 20px;
                  line-height: 20px;
                  font-size: 15px;
                  font-size: 12px;
          cursor: pointer;
                  justify-self: flex-end;
                  //padding: 3px 12px;
                  padding: 0px;
                  background: #fff;
                  color: #61a2bf;
                  text-align: center;
                  margin-right: 10px;
                  border-radius: 5px;
                }
                
                .btn:hover {
                  background: #f2f2f2;
                }
              }
            }
            
            .diagnoseInfo-box {
              display: flex;
              width: 100%;
              
              .diagnose-suggest {
                flex: 1;
              }
              
              .modify-diagnose {
                width: 162px;
                padding-right: 10px;
                padding-top: 6px;
                margin-left: 10px;
                
                .modify-btn {
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  width: 160px;
                  height: 20px;
                  font-size: 15px;
                  font-size: 12px;
          cursor: pointer;
                  border: 1px solid;
                  padding: 3px 0;
                  background: #fff;
                  color: #61a2bf;
                  border-radius: 5px;
                  box-shadow: 3px 2px 10px grey;
                  user-select: none;
                  
                  .modify-btn-icon {
                    padding-right: 2px;
                    font-size: 18px;
                  }
                }
                
                .modify-btn:hover {
                  background-color: #f2f2f2;
                }
                
                .modify-btn.disabled {
                  color: #d6d6d6;
                  cursor: default;
                  background-color: #9e9e9e;
                }
              }
            }
          }
          
          .diagnoseHeader.hospitalization {
            padding-top: 10px;
            padding-bottom: 10px;
            background-color: rgb(146, 82, 17);
          }
          
          .diagnoseHeader.operatio {
            background-color: rgb(165, 191, 108);
          }
          .diagnoseHeader.cosmetology {
            background-color: rgb(146, 27, 81);
          }
          
          .checksCon {
            .checkTypeCon {
              background: #EBEBEB;
              padding: 2px 15px;
              box-shadow: 3px 5px 5px grey;
              box-sizing: border-box;
              
              .checkHeader {
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                color: rgb(146, 146, 146);
                
                .leftCheck {
                  align-items: flex-start;
                  flex: 1;
                  
                  .mirror-box {
                    display: flex;
                    width: 100%;
                    
                    .mirror-content {
                      flex: 1;
                    }
                  }
                }
                
                .rightbtn {
                  .btn_color {
                    background: #61a2bf;
                    color: #fff;
                    padding: 6px 15px;
                    border-radius: 5px;
                    font-size: 15px;
                    width: 145px;
                    text-align: center;
                    font-size: 12px;
          cursor: pointer;
                    margin-left: 20px;
                  }
                  
                  .btn_color:hover {
                    background: #61b2bf;
                  }
                }
              }
              
              .imgsCon {
                flex-direction: row;
                align-items: center;
                flex-wrap: wrap;
                
                .imgBackCon {
                  width: 130px;
                  height: 120px;
                  position: relative;
                  padding: 5px;
                  margin-right: 5px;
                  margin-bottom: 10px;
                  flex-direction: column;
                  align-items: center;
                  justify-content: space-between;
                  background-color: #fff;
                  font-size: 12px;
          cursor: pointer;
                  
                  .img-box{
                    width: 130px;
                    height: 100px;
                    margin-bottom: 2px;
                    overflow: hidden;
                  }
                  
                  .diseasePosition {
                    font-size: 12px;
                    color: #000;
                    .wd-tag {
                      display: inline-block;
                      padding: 0 3px;
                      font-size: 10px;
                      line-height: 14px;
                      background-color: #ccc;
                      vertical-align: middle;
                      border-radius: 2px;
                      margin-left: 4px;
                    }
                    .wd-tag-active {
                      background-color: #9b59b6;
                      color: #fff;
                    }
                  }
                  
                  .diseasePosition2 {
                    width: 120%;
                    transform: scale(0.8);
                    
                  }
                  
                  .loveImg {
                    font-size: 12px;
          cursor: pointer;
                    position: absolute;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    top: 8px;
                    right: 8px;
                    padding: 2px;
                    opacity: 0.5;
                    background: #fff;
                  }
                  
                  .largeImg {
                    font-size: 12px;
          cursor: pointer;
                    position: absolute;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    top: 8px;
                    right: 35px;
                    padding: 2px;
                    opacity: 0.5;
                    background: #fff;
                  }
                }
              }
            }
          }
          
          .checksCon:nth-of-type(1) {
            .checkHeader {
              color: #61a2bf !important;
            }
          }
          
        }
      }
    }
  }
  
  .fontClass {
    color: #61a2bf;
  }
  
  .backgroundFirst {
    background: #EFF2F7 !important;
  }
  
  .backgroundFirst1 {
    background: rgb(255, 253, 233) !important;
  }
  .backgroundFirst2{
    background: #fed8d8 !important;

  }
  
  .checksCon1 {
    display: flex;
    flex-wrap: wrap;
    padding: 10px 15px;
    background-color: rgb(235, 235, 235);
    
    .image-item {
      width: 130px;
      height: 130px;
      padding: 5px;
      background-color: #fff;
      margin-right: 5px;
      margin-bottom: 10px;
      
      .image {
        width: 130px;
        height: 110px;
        background-repeat: no-repeat;
        background-position: center center;
        background-size: cover;
        cursor: pointer;
      }
      
      .title {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 20px;
        font-size: 12px;
      }
    }
  }
  
  
  .similarDialog {
    
    .el-dialog--center {
      background: #ebebeb;
      border-radius: 10px;
    }
  }
  
  .imgWrapper {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    font-size: 1.5rem;
    margin-top: 5vh;
    color: #48a3c2;
    
    .chooseImgCon {
      flex: 1;
      text-align: center;
      margin-right: 2%;
      
      .cs-text {
        margin-bottom: 2vh;
      }
    }
    
    .chooseImgCon:nth-child(2) {
      margin-right: 0px;
    }
  }
  
  .el-dialog--center .el-dialog__body {
    padding: 0 !important;
  }
  
  .el-dialog__body {
    padding: 0 !important;
  }
  
  .cosmetology-list-wrap{
    display: flex;
    flex-direction: column;
    width: 100%;
    .cosmetology-row{
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      color: #fff;
      // font-size: 12px;
      // margin: 2px 0;
      .cr-item{
        text-align: left;
        min-width: 220px;
        padding-right: 16px;
        .label{
          padding-right: 2px;
        }
      }
      .cr-num{
        min-width: 20px !important;
        font-weight: 600;
      }
      .cr-btns{
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        margin-left: auto;
        .modify-btn {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 80px;
          height: 20px;
          font-size: 12px;
          cursor: pointer;
          border: 1px solid;
          padding: 3px 0;
          background: #fff;
          color: #61a2bf;
          border-radius: 5px;
          box-shadow: 3px 2px 10px grey;
          user-select: none;
          margin-right: 10px;
          .modify-btn-icon {
            padding-right: 2px;
            font-size: 14px;
          }
        }
        .modify-btn:hover {
          background-color: #f2f2f2;
        }
        .modify-btn.disabled {
          color: #d6d6d6;
          cursor: default;
          background-color: #9e9e9e;
        }
      }
    }
  }

  .patient-max-form {
    /deep/ .el-form-item__label {
      font-size: 17px;
    }
    .patient-val {
      font-weight: bold;
    }
  }

</style>


